export const selectionExpenses = [
  { value: 'products', label: 'Products', trans: 'Продукты' },
  { value: 'alcohol', label: 'Alcohol', trans: 'Алкоголь' },
  { value: 'entertainment', label: 'Entertain', trans: 'Развлечения' },
  { value: 'health', label: 'Health', trans: 'Здоровье' },
  { value: 'transport', label: 'Transport', trans: 'Транспорт' },
  { value: 'housing', label: 'Housing', trans: 'Всё для дома' },
  { value: 'hobbies', label: 'Sports, hobbies', trans: 'Спорт и хобби' },
  { value: 'technique', label: 'Technique', trans: 'Техника' },
  {
    value: 'communal',
    label: 'Communal, communication',
    trans: 'Коммуналка и связь',
  },
  { value: 'education', label: 'Education', trans: 'Образование' },
  { value: 'other', label: 'Other', trans: 'Прочее' },
];

export const selectionIncome = [
  { value: 'salary', label: 'Salary', trans: 'З/П' },
  { value: 'income', label: 'Add. Income', trans: 'Доп. доход' },
];
